import React from 'react'
import PropTypes from 'prop-types'
import { Tabs, Typography } from '@mui/material'
import { useTheme } from '@mui/styles'
import TabLink from 'components/generic/tabs/TabLink'

const SettingsNavTabs = ({ tabs, currentTab, title }) => {
  const theme = useTheme()

  return (
    <Tabs
      value={currentTab ? currentTab.route : false}
      orientation="vertical"
      variant="fullWidth"
      TabIndicatorProps={{ style: { backgroundColor: theme.palette.background.settingsMenu } }}
    >
      <Typography letterSpacing="1px" fontSize="0.75rem" pb={1}>
        {title}
      </Typography>
      {tabs.map(tab => (
        <TabLink
          key={tab.route}
          icon={tab.icon}
          label={tab.title}
          value={tab.route}
          sx={{
            minHeight: 40,
            width: '225px',
            flexDirection: 'row',
            justifyContent: 'start',
            gap: 1,
            textTransform: 'none',
            fontWeight: '400',
            fontSize: '1rem',
            borderRadius: 8,
            '&:hover': {
              color: theme.palette.primary.main,
            },
            '&.Mui-selected': {
              backgroundColor: theme.palette.primary.lightBg,
              pointerEvents: 'none',
              fontWeight: '600',
              color: theme.palette.text.primary,
            },
          }}
        />
      ))}
    </Tabs>
  )
}

SettingsNavTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node,
      title: PropTypes.string.isRequired,
      route: PropTypes.string.isRequired,
      matchPath: PropTypes.string.isRequired,
    }),
  ).isRequired,
  currentTab: PropTypes.shape({
    icon: PropTypes.node,
    title: PropTypes.string.isRequired,
    route: PropTypes.string.isRequired,
    matchPath: PropTypes.string.isRequired,
  }),
  title: PropTypes.string.isRequired,
}

SettingsNavTabs.defaultProps = {
  currentTab: null,
}

export default SettingsNavTabs
